import { StrictMode } from 'react'
import { logger } from './utils/logger'
import { createRoot } from 'react-dom/client'
import { ClerkProvider, useAuth } from '@clerk/clerk-react'
import { ConvexProviderWithClerk } from 'convex/react-clerk'
import { convex } from './lib/convex'
import App from './App.tsx'
import { SpeedInsights } from '@vercel/speed-insights/react'
import { initCookieConsent } from './utils/cookieConsentConfig.ts'
import './style.css'

// Inicjalizacja Cookie Consent
initCookieConsent();

// Globalny nasłuch beforeinstallprompt – musi być dodany jak najwcześniej,
// aby nie przegapić zdarzenia, zanim użytkownik wejdzie na zakładkę Instalacja.
// Zapisujemy event na window i emitujemy custom event dla hooków.
window.addEventListener('beforeinstallprompt', (e: any) => {
  try {
    e.preventDefault()
      ; (window as any).__deferredInstallPrompt = e
    window.dispatchEvent(new Event('pwa:beforeinstallprompt'))
    logger.debug('📱 [global] beforeinstallprompt captured')
  } catch (err) {
    console.warn('⚠️ [global] beforeinstallprompt handler error:', err)
  }
})

window.addEventListener('appinstalled', () => {
  try {
    ; (window as any).__deferredInstallPrompt = null
    window.dispatchEvent(new Event('pwa:appinstalled'))
    logger.debug('📱 [global] appinstalled')
  } catch (err) {
    console.warn('⚠️ [global] appinstalled handler error:', err)
  }
})

const CLERK_PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY as string

if (!CLERK_PUBLISHABLE_KEY) {
  throw new Error('Missing VITE_CLERK_PUBLISHABLE_KEY environment variable')
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ClerkProvider publishableKey={CLERK_PUBLISHABLE_KEY}>
      <ConvexProviderWithClerk client={convex} useAuth={useAuth}>
        <App />
        {import.meta.env.PROD ? <SpeedInsights /> : null}
      </ConvexProviderWithClerk>
    </ClerkProvider>
  </StrictMode>,
)

// Rejestracja Service Workera (produkcja) -> TERAZ WYŁĄCZONA DLA DEBUGOWANIA
// if ('serviceWorker' in navigator && import.meta.env.PROD) {
//   window.addEventListener('load', async () => {
//     try {
//       const res = await fetch('/serviceWorker.js', { method: 'HEAD' })
//       if (res.ok) {
//         await navigator.serviceWorker.register('/serviceWorker.js')
//         logger.debug('✅ Service Worker registered')
//       } else {
//         logger.debug('ℹ️ No /serviceWorker.js — skipping registration')
//       }
//     } catch (err) {
//       console.warn('⚠️ Service Worker registration error:', err)
//     }
//   })
// }

// FORCE UNREGISTER DLA BADANIA PROBLEMU
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.ready.then((registration) => {
    registration.unregister();
    console.log('Service Worker unregistered by force script.');
    window.location.reload(); // Reload once to get fresh HTML
  }).catch(error => {
    console.error(error.message);
  });

  navigator.serviceWorker.getRegistrations().then((registrations) => {
    for (let registration of registrations) {
      registration.unregister();
      console.log('Found and unregistered SW:', registration);
    }
  });
}
